export default __webpack_public_path__ + "media/src/usersite/images/header/sns_banners/pc_sns_insta-1799b62b6c895077a5751e0b028014a8.png";